exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-form-field {\r\n    padding: 5px;\r\n}\r\n\r\n.mat-form-field {\r\n    width: 260px !important;\r\n}\r\n\r\n.form-label {\r\n    color: darkgrey;\r\n}\r\n\r\n.small-dialog{\r\n    padding-left: 8px;\r\n}\r\n\r\n.table-container {\r\n    width: 100%;\r\n    position: relative;\r\n    padding-left: 10px;\r\n    padding-bottom: 5px;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.error {\r\n    color: red;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/processor-closer-pipeline-reassignment.component.css
// module id = ../../../../../src/app/processor-closer-pipeline-reassignment/processor-closer-pipeline-reassignment.component.css
// module chunks = main